/**
 * Constants for icons from Amplify's design system--see
 * https://amplify-education.github.io/styles/amplify-icons.html
 */

export const AmplifyIcons = {
    CHECKMARK: 'checkmark',
};

export const ICON_PREFIX = 'icon';

/**
 * Constructs the appropriate css class for the desired icon as expected
 * by amplify styles css.
 *
 * Example: getCssClassForIcon('pdf') -> 'icon-v2-pdf'
 *
 * @param {string} icon - one of AmplifyIcons
 * @param {string} version - e.g. "v2", "v3"
 */
export const getCssClassForIcon = (icon, version = 'v2') => {
    if (!Object.values(AmplifyIcons).includes(icon)) {
        // eslint-disable-next-line no-console
        console.warn(`Unknown Amplify icon "${icon}"--no icon will display`);
    }
    return `${ICON_PREFIX}-${version}-${icon}`;
};
